export function adviceRoomExistingImagesApi(path: string) {
  return {
    path,
  };
}
